/* ==========================================================================
   Tapsara — product page enhancements (changes 5, 6 and 7). 07 Sep 2026.
   Sticky-bar variant pickers, quantity stepper, review-CTA animation and
   review panel. Optimised 14 Sep 2026 — see "WORK AVOIDANCE" below.

   This script only shows/hides a bar, relocates existing controls, and
   mirrors what is already on the page. Adding to cart is delegated to the
   theme's own submit button, changing a variant to the theme's own option
   buttons, and changing quantity to the theme's own qty-box buttons, so the
   existing ajax cart, GoKwik, free-gift and discount logic all run unchanged.

   WORK AVOIDANCE
   Two things were measured doing far more than they needed to:

   1. The MutationObserver on the buy box fires on class changes, and 75 of
      every 84 mutations come from Swiper relabelling slides as the shopper
      swipes the gallery. Each burst ran a full sync. sync() now compares a
      cheap text signature of the buy box first and returns immediately when
      nothing it cares about has moved, so a swipe costs a handful of string
      reads instead of a rebuild. The gallery photo still follows the swipe —
      that part is one lookup and a string compare.

   2. measureChrome() reads three bounding boxes, which forces layout. It was
      running inside sync() AND on every scroll frame. It now runs only when
      something can actually have changed the furniture: load, resize, the
      moment the bar shows or hides, and the moment the theme's back-to-top
      button appears (watched with a one-element observer, because that
      button turns up mid-scroll and the floating WhatsApp button is spaced
      off it). Scrolling reads one box, not four.
   ========================================================================== */
(function () {
  'use strict';

  var productInfo = document.querySelector('product-info[id^="MainProduct-"][data-section]');

  /* ======================================================================
     Review summary panel (change 7)

     Judge.me renders its widget client-side, so the panel is parked in the
     page by Liquid and moved in once the widget exists. A MutationObserver
     rather than a polling timer: it fires the moment Judge.me writes into the
     container, and costs nothing while nothing is happening.
     Kept independent of the buy-box code below so a failure in one cannot
     take out the other.
     ====================================================================== */
  (function () {
    var panel = document.querySelector('[data-tps-review-summary]');
    if (!panel) return;

    var host = document.getElementById('judgeme_product_reviews');
    if (!host) return;

    var placed = false;

    /* Pulse the write-review button the first time it scrolls into view, and
       only then. The animation stops itself after three runs; the class is
       taken off so a later re-render cannot leave it looping. */
    function callAttention(group, button) {
      if (!group || !button) return;
      if (!('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        group.classList.add('is-calling');
        button.classList.add('is-calling');
        button.addEventListener('animationend', function () {
          group.classList.remove('is-calling');
          button.classList.remove('is-calling');
        });
      }, { threshold: 0.6 });

      io.observe(button);
    }

    function place() {
      if (placed) return false;
      var widget = host.querySelector('.jm-review-widget');
      if (!widget) return false;

      placed = true;
      host.insertBefore(panel, host.firstChild);
      host.classList.add('tps-reviews-2col');
      panel.hidden = false;

      /* Hand "Write a review" over to Judge.me's own button, so the review
         form and its validation stay entirely theirs. The label and the
         button are hidden together as one group, and dropped together if
         Judge.me's control is never found. */
      var group = panel.querySelector('[data-tps-write-review-group]');
      var mine = panel.querySelector('[data-tps-write-review]');
      if (group && mine) {
        var theirs = null;
        var candidates = host.querySelectorAll('button, a');
        for (var i = 0; i < candidates.length; i++) {
          if (/write a review/i.test(candidates[i].textContent || '')) {
            theirs = candidates[i];
            break;
          }
        }
        if (theirs) {
          group.hidden = false;
          mine.addEventListener('click', function () { theirs.click(); });
          callAttention(group, mine);
        } else if (group.parentNode) {
          group.parentNode.removeChild(group);
        }
      }
      return true;
    }

    if (place()) return;

    var obs = new MutationObserver(function () {
      if (place()) obs.disconnect();
    });
    obs.observe(host, { childList: true, subtree: true });

    /* Judge.me never turned up — stop watching and leave the page as it was. */
    setTimeout(function () { obs.disconnect(); }, 20000);
  })();

  /* ======================================================================
     Sticky add-to-cart, floating WhatsApp, share placement (changes 5 & 6)
     ====================================================================== */
  var bar = document.querySelector('.tps-sticky-atc');
  if (!bar || !productInfo) return;

  var sectionId = productInfo.getAttribute('data-section');
  var realBtn = document.getElementById('ProductSubmitButton-' + sectionId);
  var anchor = (realBtn && realBtn.closest('.pr-form-button')) || realBtn;
  if (!realBtn || !anchor) return;

  var btn = bar.querySelector('.tps-sticky-atc__btn');
  if (!btn) return;
  var btnLabel = bar.querySelector('.tps-sticky-atc__btn-label');
  var priceEl = bar.querySelector('.tps-sticky-atc__price');
  var optsWrap = bar.querySelector('[data-tps-opts]');
  var qtyWrap = bar.querySelector('[data-tps-qty]');
  var qtyVal = bar.querySelector('[data-tps-qty-val]');
  var qtyMinus = bar.querySelector('[data-tps-qty-minus]');
  var qtyPlus = bar.querySelector('[data-tps-qty-plus]');
  var thumbImg = bar.querySelector('.tps-sticky-atc__thumb img');
  var root = document.documentElement;

  /* ---- share button sits beside the wishlist heart ----------------------
     The theme renders it at the very bottom of the buy column, below four
     accordion rows, where it reads as a fifth accordion row that lost its
     chevron and where almost nobody scrolls before deciding to buy.
     The existing element is MOVED rather than rebuilt, so its data-modal
     hook and any listeners bound to it come with it and the share modal
     behaves exactly as before. The wishlist button is not re-parented.   */
  (function () {
    var title = productInfo.querySelector('.product-title');
    var share = productInfo.querySelector('.form-group [data-modal="share-modal"]');
    if (!title || !share) return;
    var group = share.closest('.form-group');
    title.appendChild(share);
    title.classList.add('tps-has-actions');
    if (group && !group.querySelector('button, a')) {
      group.classList.add('tps-empty');
    }
  })();

  /* ---- float the WhatsApp button against the viewport -------------------
     The buy box sits inside the section's scroll-animation wrapper, which is
     transformed. A transformed ancestor becomes the containing block for
     position:fixed, so the button would anchor to the product block instead
     of the window. Re-parenting it to <body> is the whole fix.            */
  var wa = document.querySelector('.tapsara-wa-help-btn.tps-wa-float');
  if (wa && wa.parentNode !== document.body) document.body.appendChild(wa);

  var backToTop = document.querySelector('.back-to-top');

  /* ======================================================================
     Variant pickers in the bar

     Read from the real option controls rather than from Liquid, because the
     theme re-renders the section on every variant change: anything rendered
     once at page load would go stale. Selecting an option CLICKS the theme's
     own radio for it — the bar never touches the form, the URL, the price or
     the cart itself.
     ====================================================================== */
  function optionRadios() {
    return productInfo.querySelectorAll('.pr-option input[type="radio"]');
  }

  function radioGroups() {
    var groups = [];
    var byName = {};
    optionRadios().forEach(function (input) {
      var name = (input.name || '').trim();
      if (!name) return;
      if (!byName[name]) {
        byName[name] = {
          name: name,
          /* "Color-1" is the theme's own naming: option name, then its
             position in the product's option list. */
          label: name.replace(/-\d+$/, ''),
          inputs: []
        };
        groups.push(byName[name]);
      }
      byName[name].inputs.push(input);
    });
    return groups;
  }

  function isSoldOut(input) {
    var label = input.nextElementSibling;
    var cls = (label && label.className) || '';
    return input.disabled || /sold-out|unavailable|disabled/i.test(cls);
  }

  function pressOption(groupName, value) {
    var target = null;
    optionRadios().forEach(function (input) {
      if ((input.name || '').trim() === groupName && input.value === value) target = input;
    });
    if (!target || target.checked) return;
    /* Click the label rather than the input where the theme hides the input:
       a hidden input can refuse a synthetic click in some browsers. */
    var label = target.nextElementSibling;
    if (label && label.tagName === 'LABEL') label.click();
    else target.click();
  }

  function refreshOpts() {
    if (!optsWrap) return;
    var groups = radioGroups();
    for (var i = 0; i < groups.length && i < optsWrap.children.length; i++) {
      var sel = optsWrap.children[i].querySelector('select');
      if (!sel) continue;
      var g = groups[i];
      for (var j = 0; j < g.inputs.length && j < sel.options.length; j++) {
        var input = g.inputs[j];
        sel.options[j].disabled = isSoldOut(input) && !input.checked;
        if (input.checked) sel.value = input.value;
      }
    }
  }

  function buildOpts() {
    if (!optsWrap) return;
    var groups = radioGroups();

    /* Rebuild only when the option list itself changes. A plain variant
       switch keeps the same signature, so the selects are updated in place
       and a picker that is open on a phone is not torn out from under the
       shopper's finger. */
    var sig = groups
      .map(function (g) {
        return g.name + ':' + g.inputs.map(function (i) { return i.value; }).join(',');
      })
      .join('|');
    if (sig === optsWrap.getAttribute('data-sig')) {
      refreshOpts();
      return;
    }
    optsWrap.setAttribute('data-sig', sig);

    while (optsWrap.firstChild) optsWrap.removeChild(optsWrap.firstChild);

    groups.forEach(function (g) {
      var field = document.createElement('label');
      field.className = 'tps-sticky-atc__opt';

      var label = document.createElement('span');
      label.className = 'tps-sticky-atc__opt-label';
      label.textContent = g.label;

      var sel = document.createElement('select');
      sel.setAttribute('aria-label', g.label);

      g.inputs.forEach(function (input) {
        var opt = document.createElement('option');
        opt.value = input.value;
        opt.textContent = input.value;
        sel.appendChild(opt);
      });

      sel.addEventListener('change', function () {
        pressOption(g.name, sel.value);
      });

      field.appendChild(label);
      field.appendChild(sel);
      optsWrap.appendChild(field);
    });

    refreshOpts();
  }

  /* ======================================================================
     Quantity stepper

     Same delegation as everything else: the stepper presses the theme's own
     qty-box buttons, which is what the cart, the free-gift rules and the
     discount tiers already listen to. It never writes to the input.
     ====================================================================== */
  function themeQtyBox() {
    return productInfo.querySelector('qty-box, .qty-box');
  }

  function themeQtyInput() {
    return productInfo.querySelector('input[name="quantity"]');
  }

  function pressQty(which) {
    var box = themeQtyBox();
    if (!box) return;
    var b = box.querySelector('button[name="' + which + '"]');
    if (!b || b.disabled || b.classList.contains('disabled')) return;
    b.click();
  }

  function refreshQty() {
    if (!qtyWrap || qtyWrap.hidden) return;
    var box = themeQtyBox();
    var input = themeQtyInput();
    if (!box || !input) return;

    if (qtyVal) qtyVal.textContent = input.value || '1';

    ['minus', 'plus'].forEach(function (which) {
      var theirs = box.querySelector('button[name="' + which + '"]');
      var ours = which === 'minus' ? qtyMinus : qtyPlus;
      if (!theirs || !ours) return;
      ours.disabled = theirs.disabled || theirs.classList.contains('disabled');
    });
  }

  if (qtyWrap && qtyMinus && qtyPlus && themeQtyBox() && themeQtyInput()) {
    qtyWrap.hidden = false;
    qtyMinus.addEventListener('click', function () { pressQty('minus'); });
    qtyPlus.addEventListener('click', function () { pressQty('plus'); });
  }

  /* ---- keep the fixed furniture from stacking on top of each other ------
     The phone's bottom menu is position:sticky, not fixed, and it is a direct
     child of <body>. A sticky element is held by its parent's CONTENT box, so
     padding on <body> lets it unstick that far before the end of the page —
     which is why the bar ended up drawn below the menu with a white strip
     under it. The class below lets the stylesheet put the room ABOVE the menu
     instead when the menu is there, and fall back to padding when it is not
     (desktop, where the menu is display:none).

     THREE bounding boxes are read here, which forces layout, so this is
     called only when the furniture can actually have changed — never per
     scroll frame. See the callers below.                                  */
  function measureChrome() {
    var nav = document.querySelector('.mobile-sticky-menu');
    var navH = 0;
    if (nav && getComputedStyle(nav).display !== 'none') {
      navH = nav.getBoundingClientRect().height || 0;
    }
    root.style.setProperty('--tps-nav-h', Math.round(navH) + 'px');
    document.body.classList.toggle('tps-has-bottom-nav', navH > 0);

    var atcH = bar.classList.contains('is-visible')
      ? bar.getBoundingClientRect().height || 0
      : 0;
    root.style.setProperty('--tps-atc-h', Math.round(atcH) + 'px');

    if (backToTop) {
      var r = backToTop.getBoundingClientRect();
      if (r.height) {
        root.style.setProperty(
          '--tps-wa-base',
          Math.round(window.innerHeight - r.top + 16) + 'px'
        );
      }
    }
  }

  /* The theme's back-to-top button is hidden at the top of the page and fades
     in part way down, so at load it has no box to measure and the WhatsApp
     button falls back to its default offset. Watching that one element for
     its show/hide class costs nothing and re-measures at the only moment the
     answer changes — which is what the per-scroll-frame measure used to be
     doing by brute force. */
  if (backToTop) {
    new MutationObserver(measureChrome).observe(backToTop, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  /* ---- show the bar once the real buy box has scrolled past -------------
     A plain scroll check rather than an IntersectionObserver: an anchor link
     or a restored scroll position can jump straight from "below the viewport"
     to "above" it, which is not an intersection change and would leave the
     bar stuck hidden.

     One bounding box per frame, and the expensive measure only on the frame
     where the bar actually changes state.                                  */
  var shown = false;
  var ticking = false;

  function update() {
    var next = anchor.getBoundingClientRect().bottom < 0;
    if (next === shown) return;
    shown = next;
    bar.classList.toggle('is-visible', shown);
    bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
    document.body.classList.toggle('tps-has-sticky-atc', shown);
    measureChrome();
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    raf(function () {
      ticking = false;
      update();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- mirror the live price, image and button state -------------------- */
  function text(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function livePrice() {
    var priceBox = productInfo.querySelector('#price-' + sectionId) ||
      productInfo.querySelector('.price-box');
    if (!priceBox) return '';
    return text(priceBox.querySelector('.new-price')) ||
      text(priceBox.querySelector('.price-item--sale')) ||
      text(priceBox.querySelector('.price-item--last')) ||
      text(priceBox.querySelector('.price-item'));
  }

  /* The gallery photo is the one thing that SHOULD follow a swipe, and it is
     cheap: one lookup and a string compare. */
  function mirrorThumb() {
    if (!thumbImg) return;
    var active = productInfo.querySelector(
      '.slider-big .swiper-slide-active img, .slider-big .swiper-slide img'
    );
    if (active && active.currentSrc && thumbImg.src !== active.currentSrc) {
      thumbImg.src = active.currentSrc;
    }
  }

  /* Everything the bar shows, as one string. Text and property reads only —
     no geometry — so building it does not force layout. */
  function buyBoxState() {
    var parts = [];
    optionRadios().forEach(function (input) {
      if (input.checked) parts.push(input.value);
      if (isSoldOut(input)) parts.push('-' + input.value);
    });
    parts.push(livePrice());
    parts.push(realBtn.hasAttribute('disabled') ? 'off' : 'on');
    parts.push(text(realBtn.querySelector('.cart-title')));
    var qi = themeQtyInput();
    parts.push(qi ? qi.value : '');
    return parts.join('|');
  }

  var lastState = null;

  function sync(force) {
    mirrorThumb();

    var state = buyBoxState();
    if (force !== true && state === lastState) return;
    lastState = state;

    buildOpts();
    refreshQty();

    var price = livePrice();
    if (priceEl && price && /\d/.test(price)) priceEl.textContent = price;

    btn.disabled = realBtn.hasAttribute('disabled');
    if (btnLabel) {
      btnLabel.textContent = text(realBtn.querySelector('.cart-title')).split('Extra Discount')[0].trim() ||
        btnLabel.getAttribute('data-default') || 'Add to cart';
    }
  }

  var syncTimer;
  function queueSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 120);
  }

  new MutationObserver(queueSync).observe(productInfo, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled', 'class', 'value', 'src', 'checked']
  });

  /* The quantity input's value property changes without an attribute change,
     so the observer above does not see it. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity') refreshQty();
  }, true);

  /* ---- the bar's button just presses the theme's own button ------------- */
  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    realBtn.click();
  });

  window.addEventListener('resize', function () {
    measureChrome();
    update();
  }, { passive: true });

  window.addEventListener('load', function () {
    measureChrome();
    update();
    sync(true);
  });

  measureChrome();
  update();
  sync(true);
})();
